import { useEffect, useRef } from "react";
import { Popper, ClickAwayListener, styled } from "@mui/material";
import clsx from "clsx";
import { HexColorPicker } from "react-colorful";
import { useToggle } from "hooks/useToggle";

const ContainerStyled = styled("div")({
  position: "relative",
});

const SwatchStyled = styled("div")({
  width: "32px",
  height: "32px",
  borderRadius: "8px",
  border: "1px solid #fff",
  boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
});

const PopperStyled = styled(Popper)({
  zIndex: 1000,
  position: "absolute",
  top: "calc(100% + 2px)",
  left: 0,
  borderRadius: "8px",
  boxShadow: "0 6px 12px rgba(0, 0, 0, 0.15)",
});
const PickerWrapper = styled("div")(({ theme }) => ({
  width: "300px",
  "& .react-colorful": {
    width: "auto",
  },
  "& .preset-options": {
    display: "flex",
    padding: theme.spacing(1.5),
    flexWrap: "wrap",
    backgroundColor: theme.palette.background.default,
    "& .swatch-item": {
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: "4px",
      padding: 0,
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      outline: "none",
    },
  },
}));

const PRESET_COLORS = [
  "#BE80ED", // light purple
  "#60AA82", // green
  "#81C1DD", // light blue
  "#E9D251", // yellow
  "#E7796D", // coral
  "#8C4EBA", // purple
  "#376D4E", // dark green
  "#3F7B98", // blue
  "#B16022", // orange
  "#B94335", // red
  "#F5F5F5", // very light gray (close to white)
  "#A3E4D7", // mint
  "#FFD6A5", // peach
  "#C1B2FA", // lavender
  "#FFB7B2", // light pink
  "#B2F7EF", // aqua
];

const ColorPickerUnstyled = ({
  color,
  isDisabled,
  isPopperOpen,
  onChange,
  onClick,
  className,
}) => {
  const { isOpen, close, open } = useToggle();
  const colorPickerRef = useRef(null);

  useEffect(() => {
    if (typeof isPopperOpen !== "boolean") {
      return;
    }
    if (isPopperOpen) {
      open();
    } else {
      close();
    }
  }, [close, isPopperOpen, open]);

  return (
    <ContainerStyled onClick={onClick}>
      <SwatchStyled
        ref={colorPickerRef}
        className={clsx("swatch", className)}
        style={{ backgroundColor: color }}
        onClick={() => {
          if (!isDisabled) {
            open();
          }
        }}
      />
      <PopperStyled
        disablePortal
        open={isOpen}
        anchorEl={colorPickerRef.current}
        className="popover"
        placement="bottom-start"
      >
        <ClickAwayListener onClickAway={close}>
          <PickerWrapper className="picker-wrapper">
            <HexColorPicker color={color} onChange={onChange} />
            <div className="preset-options">
              {PRESET_COLORS.map((presetColor) => (
                <button
                  key={presetColor}
                  className="swatch-item"
                  style={{ background: presetColor }}
                  onClick={() => onChange(presetColor)}
                />
              ))}
            </div>
          </PickerWrapper>
        </ClickAwayListener>
      </PopperStyled>
    </ContainerStyled>
  );
};

const ColorPicker = styled(ColorPickerUnstyled)({});

export default ColorPicker;
